/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since 2017.6.15
 */
let {
  CircleMarker
} = L;

import load from "@/utils/Loader";
/**
 * 矢量图元
 */
export default L.VectorMarker = L.VectorMarker || CircleMarker.extend({
  /**
   * 
   */
  options: {
    src: 'circle',
    // 闪烁,常用于水雨情预警
    // glow: false,
    // 线条粗细
    weight: 1,
    // 颜色
    color: '#000',
    // 是否绘制线条
    stroke: true,
    // 是否填充
    fill: true,
    // 圆的半径，等腰三角形的底边长
    radius: 5,
    // 弧度单位 Math.random() * 2 * Math.PI 三角形角度 
    angle: 0,
    // 移入上调层级
    riseOnHover: true
  },
  initialize: function (latlng, options) {
    CircleMarker.prototype.initialize.call(this, latlng, options);
    this._radiusY = this.options.radiusY;
  },
  // _updateBounds: function () {
  //   var r = this._radius,
  //     r2 = this._radiusY || r,
  //     w = this._clickTolerance() ,
  //     p = [r + w, r2 + w];
  //   this._pxBounds = new L.Bounds(this._point.subtract(p), this._point.add(p));
  // },
  // _empty: function () {
  //   return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
  // },
  // 
  // _containsPoint: function (p) {
  //   return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
  // },

  _clickTolerance: function () {
    return CircleMarker.prototype._clickTolerance.call(this) + 1;
  },
  /**
   * @override
   */
  _project() {
    this._point = this._map.latLngToLayerPoint(this._latlng);
    let {
      options
    } = this;
    let {
      offset,
      icon
    } = options;
    // 图元整体偏移
    if (offset) {
      this._point = this._point.add(offset);
    }
    // 图元锚点偏移
    if (icon && icon.iconAnchor) {
      this._point = this._point.subtract(icon.iconAnchor);
    }
    this._updateBounds();
  },
  /**
   * @override
   */
  beforeAdd(map) {
    let {
      options
    } = this;
    CircleMarker.prototype.beforeAdd.call(this, map);
    // 确保 renderer is canvas,且canvas是唯一的。否则图层相互覆盖影响;
    if (!map.options.preferCanvas && !options.renderer) {
      options.renderer = map.__canvas = map.__canvas || L.canvas();
    }
    // 用于旋转
    this.on('rotate', e => {
      options.angle = e.rotation;
      this.redraw();
    })
  },
  /**
   * @override
   * todo 优化性能，预执行
   */
  _updatePath() {
    let that = this;
    let {
      options,
      _renderer
    } = that;
    let {
      src
    } = options;

    switch (src) {
      case 'triangle':
        return _renderer._updateTriangle(that);
      case 'rect':
        if (!options.radiusY) {
          that._radius = that._radiusY = 8;
        }
        return _renderer._updateRect(that);
      case 'circle':
        return _renderer._updateCircle(that);
      case 'line': //旋转句柄,用于编辑旋转
        return _renderer._updateLine(that);
      case 'balloon': //
        return _renderer._updateBalloon(that);
      default:
        if (that._loader) {
          _renderer._updateIcon(that);
        } else {
          // todo
          if (src && src.indexOf('/') !== 0 && !src.includes('http')) {
            src = options.src = T + src;
          }!that.loader && (that.loader = load(src)).then(img => {
            that._loader = img;
            that._radius = img.width / 2;
            that._radiusY = img.height / 2;
            that.redraw();
          })
        }
        break;
    }

  }
})



// WEBPACK FOOTER //
// ./src/feature/VectorMarker.js